import i18next from 'i18next';
import ar from './ar';

i18next.init({
  lng: 'ar',
  interpolation: { escapeValue: false },
  resources: { ar },
});
